import React, { useState } from "react";

//UI Material
import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
} from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local componentes
import ModalWindow from "../Modal";
import Form from "../basics/Form";

//Material Icons
import { Add } from "@mui/icons-material";

const taskTypes = [
  "Actualización",
  "Cotización",
  "Entrega o Encomienda",
  "Ensamble",
  "Impresión 3D",
  "Instalación",
  "Recolección o Compra de Materiales",
  "Reparación",
  "Otra",
];

export default function TaskDrawer({ open, setOpen, getData, user }) {
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for loading request
  const [isLoading, setIsLoading] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");
  //State for new data
  const [currentData, setCurrentData] = useState();

  //Task form
  const newTask = [
    {
      selection: "selector",
      id: "title",
      initialValue: 0,
      xs: 12,
      md: 6,
      label: "Tipo de tarea",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "",
      content: taskTypes,
      style: { minWidth: "100%" },
    },
    {
      selection: "date_picker",
      id: "dueDate",
      initialValue: new Date(),
      xs: 12,
      md: 6,
      label: "Fecha de finalización",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "Fecha de finalización",
      content: [],
    },
    {
      selection: "textfield",
      id: "description",
      initialValue: "",
      xs: 12,
      md: 12,
      label: "Instrucciones",
      multiline: true,
      type: "text",
      inputProps: {},
      placeholder: "Instrucciones",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "link",
      initialValue: "",
      xs: 12,
      md: 12,
      label: "Enlace",
      multiline: true,
      type: "text",
      inputProps: {},
      placeholder: "Enlace",
      content: [],
      style: {},
    },
  ];

  // ==========>Component Functions<==========
  //Function to create new task
  const createNewTask = async () => {
    setIsLoading(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost("/tasks/create", {
        title: taskTypes[currentData.title],
        description: currentData.description,
        dueDate: new Date(currentData.dueDate).toISOString(),
        link: currentData.link,
        assignedTo: user,
      });
      const jsonResponse = await requestResponse.json();
      if (jsonResponse.status === "ok") {
        setModalText("Tarea creada.");
        setModalDescription(`Se ha creado la tarea correctamente.`);
      } else {
        setModalText("No se pudo crear la tarea.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      setModalText("No se pudo crear la tarea.");
      setModalDescription(
        "Error al crear la tarea, por favor verifica tu conexión a internet e inténtalo nuevamente."
      );
    }
    setModalOpen(true);
    setIsLoading(false);
    getData();
  };

  // ==========> Component <==========
  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <Stack>
            {typographyForSubtitles("Asignar Nueva Tarea", "secondary")}
            {typographyForText(`para ${user}`, "secondary")}
          </Stack>
        </Grid>
        <Form data={newTask} handleStateChange={setCurrentData} />
        <Grid item xs={12} align="right">
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => setOpen(false)}
            >
              {"Cancelar"}
            </Button>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                onClick={() => {
                  createNewTask();
                }}
              >
                {"Registrar tarea"}
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
          setOpen(false);
        }}
      />
    </SwipeableDrawer>
  );
}
